module.exports = __webpack_public_path__ + "static/media/Market_Analysis.4719635c.png";